<ng-container *ngIf="mode === 'view'">
  <ng-container *ngIf="callSign; else elseTemplate">
    <button mat-button [matTooltip]="'users.teams.callSignsTooltipClickToEdit' | t" (click)="toggleMode()">
      {{ callSign }}
      <span class="team-name" *ngIf="team">({{ team.name }})</span>
    </button>
  </ng-container>
  <ng-template #elseTemplate>
    <button mat-button [matTooltip]="'users.teams.callSignsTooltipClickToAdd' | t" (click)="toggleMode()">{{ 'users.teams.callSignsActionAdd' | t }}</button>
  </ng-template>
</ng-container>

<ng-container *ngIf="mode === 'edit'">
  <div class="remove-call-sign-container">
    <span
      *ngIf="callSign"
      pill
      [matTooltip]="'users.teams.callSignsActionRemove' | t"
      matTooltipPosition="below"
      class="remove-pill"
      (click)="deleteCallSign()"
    >
      <sn-icon class="remove-icon">clear</sn-icon>
    </span>
    <mat-form-field floatLabel="never">
      <input
        matInput
        autofocus
        [placeholder]="'users.teams.callSignPlaceholderEnter' | t"
        [(value)]="callSign"
        [formControl]="callSignControl"
        [matAutocomplete]="callSignsAutocomplete"
      />
    </mat-form-field>
  </div>

  <mat-autocomplete
    class="call-signs-autocomplete"
    #callSignsAutocomplete
    (optionSelected)="setCallSign($event)"
  >
    <mat-option
      *ngFor="let callSign of callSignList; trackBy: trackCallSign"
      [value]="callSign.name"
    >
      {{ callSign.name }}
    </mat-option>
  </mat-autocomplete>
</ng-container>
